 /* eslint-disable */
import React, { useEffect, useState,  useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { useDispatch } from 'react-redux'
import { createClient } from '../../actions/clientActions'
import { useLocation } from 'react-router-dom';

import { useSnackbar } from 'react-simple-snackbar'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const baseURL =  'http://localhost:5000';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddClient = ({ setOpen, open }) => {

    const location = useLocation()
    const formRef = useRef();
    const [clientData, setClientData] = useState({ name: '', email: '', phone: '', address: '', city:'', state:'', fax:'', website: '', dba:''})
    const dispatch = useDispatch()
    const user = JSON.parse(localStorage.getItem('profile'))
       // eslint-disable-next-line 
       const [openSnackbar, closeSnackbar] = useSnackbar()


    useEffect(() => {
      var checkId = user?.result?.id
      if(checkId !== undefined) {
        setClientData({...clientData, userId: [checkId]})
      } else {
        setClientData({...clientData, userId: [user?.result?.googleId]})
      }
    },[location])
   

    const handleSubmitClient =(e)=> {
        e.preventDefault()
        
        const formData = new FormData(formRef.current);
        for (const key in clientData) {
          formData.append(key, clientData[key]);
        }
        formData.append("userId", user?.result?.id);

         const aML_ProgramFile = document.getElementById('aML_Program');
         if (aML_ProgramFile.files.length>0)
            formData.append("aML_Program", aML_ProgramFile.files[0]);

         const business_LicenseFile = document.getElementById('business_License');
         if (business_LicenseFile.files.length>0)
         formData.append("business_License", business_LicenseFile.files[0]);
         
         
         dispatch(createClient(formData, openSnackbar))
        
         clear()
         handleClose()
    }

  const clear =() => {
    setClientData({ name: '', email: '', phone: '', address: '', city:'', state:'', fax:'', website: '', dBA:''})
  }
    
  const handleClose = () => {
    setOpen(false);
  };


  const inputStyle = {
      display: "block",
      padding: "1.4rem 0.75rem",
      width: "100%",
      fontSize: "0.8rem",
      lineHeight: 1.25,
      color: "#55595c",
      backgroundColor: "#fff",
      backgroundImage: "none",
      backgroundClip: "padding-box",
      borderTop: "0",
      borderRight: "0",
      borderBottom: "1px solid #eee",
      borderLeft: "0",
      borderRadius: "3px",
      transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
  }

  const focus = {
    "input:focus, textarea:focus": { outline: "0", borderBottomColor: "#ffab00" }
  }
  

  return (
    <div>
        <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth>
            <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{paddingLeft: '20px', color: 'white'}}>
                New Customer
            </DialogTitle>
            <DialogContent dividers>
           

          <div className="customInputs">
              <input 
                placeholder="Name" 
                style={inputStyle} 
                name='name' 
                type='text'  
                onChange={(e) => setClientData({...clientData, name: e.target.value})}
                value={clientData.name} 
              />

              <input 
                placeholder="Email" 
                style={inputStyle} 
                name='email' 
                type='text' 
                onChange={(e) => setClientData({...clientData, email: e.target.value})}
                value={clientData.email} 
              />
              <input 
                placeholder="Phone" 
                style={inputStyle} 
                name='phone' 
                type='text'  
                onChange={(e) => setClientData({...clientData, phone: e.target.value})}
                value={clientData.phone} 
              />
              <input 
                placeholder="Address" 
                style={inputStyle} 
                name='address' 
                type='text' 
                onChange={(e) => setClientData({...clientData, address: e.target.value})}
                value={clientData.address} 
              />

              <input
                placeholder="City"
                style={inputStyle}
                name='city'
                type='text'
                onChange={(e) => setClientData({ ...clientData, city: e.target.value })}
                value={clientData.city}
              />

              <input
                placeholder="State"
                style={inputStyle}
                name='state'
                type='text'
                onChange={(e) => setClientData({ ...clientData, state: e.target.value })}
                value={clientData.state}
              />

               <input
                placeholder="Fax"
                style={inputStyle}
                name='fax'
                type='text'
                onChange={(e) => setClientData({ ...clientData, fax: e.target.value })}
                value={clientData.fax}
              />

              <input
                placeholder="Web Site"
                style={inputStyle}
                name='website'
                type='text'
                onChange={(e) => setClientData({ ...clientData, website: e.target.value })}
                value={clientData.website}
              />
              <input
                placeholder="DBA"
                style={inputStyle}
                name='dba'
                type='text'
                onChange={(e) => setClientData({ ...clientData, dba: e.target.value })}
                value={clientData.dba}
              />
               <input
                 placeholder="Tax ID/ EIN"
                 style={inputStyle}
                 name='taxId'
                 type='text'
                 onChange={(e) => setClientData({ ...clientData, taxId: e.target.value })}
                 value={clientData.taxId}
               />
              <label for="aML_Program" style={inputStyle}>Upload AML Program</label>
               <input
                placeholder="AML Program"
                style={inputStyle}
                name='aML_Program'
                id='aML_Program'
                type='file'

              />

              <label for="business_License" style={inputStyle}>Upload Business License</label>
               <input
                placeholder="Business License"
                style={inputStyle}
                name='business_License'
                id='business_License'
                type='file'

              />
             
          </div>

            </DialogContent>
            <DialogActions>
            <Button autoFocus onClick={handleSubmitClient} variant="contained" style={{marginRight: '25px'}} >
                Save Customer
            </Button>
            </DialogActions>
      </Dialog>
        </div>
    </div>
  );
}

export default AddClient